"use strict";
var Observable_1 = require('../../Observable');
var sampleTime_1 = require('../../operator/sampleTime');
Observable_1.Observable.prototype.sampleTime = sampleTime_1.sampleTime;
//# sourceMappingURL=sampleTime.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/sampleTime.js
 ** module id = 588
 ** module chunks = 2
 **/